var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{staticClass:"reel flex overflow-hidden flex-col xm:flex-row"},[_c('PublishedReelPlayer',{attrs:{"video":_vm.video,"autoplay":_vm.autoplay}}),(_vm.showClipList)?_c('div',{staticClass:"reel-right relative"},[_c('PublishedClipList')],1):_vm._e()],1):_c('div',{staticClass:"flex justify-center items-center"},[_c('Spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }